export const API_URL = process.env.REACT_APP_WEVIEWS_SERVER_URL;